import { create } from "zustand";
import { persist } from "zustand/middleware";

export type MapProvider = "google" | "libre";

const ENV_DEFAULT = (import.meta.env.VITE_MAP_PROVIDER as MapProvider) || "google";

interface MapProviderState {
  provider: MapProvider;
  setProvider: (provider: MapProvider) => void;
}

export const useMapProviderStore = create<MapProviderState>()(
  persist(
    (set) => ({
      provider: ENV_DEFAULT === "libre" ? "libre" : "google",
      setProvider: (provider) => set({ provider }),
    }),
    { name: "map-provider" },
  ),
);
